import { featuresData } from '@/mocks/homeData';

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading">
            为什么选择我们
          </h2>
          <p className="text-foreground-500 text-sm mt-2">三大核心优势，重新定义在线观影体验</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="group text-center p-6 md:p-8 bg-background-100 rounded-2xl transition-all duration-300 hover:-translate-y-1"
            >
              <span className="inline-flex w-14 h-14 md:w-16 md:h-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4 md:mb-5">
                <i className={`${feature.icon} text-2xl md:text-3xl`}></i>
              </span>
              <h3 className="text-lg font-bold text-foreground-900 mb-3 font-heading">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}